<template>
    <div class="token-search">
        <input type="text" class="form-control" placeholder="Search tokens by name, symbol, or mint..." v-model="query" @input="searchTokens">
        <ul v-if="results.length > 0" class="list-group position-absolute mt-1" style="z-index: 1000;">
            <li v-for="token in results" :key="token.mint" class="list-group-item list-group-item-action">
                <a :href="`/tokens/${token.mint}`" class="text-decoration-none d-flex align-items-center">
                    <img v-if="token.logoURI" :src="token.logoURI" :alt="token.symbol" class="me-2" style="width: 24px; height: 24px;">
                    <div>
                        <div class="fw-bold">{{ token.name }}</div>
                        <small class="text-muted">{{ token.symbol }}</small>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import debounce from 'lodash/debounce';

const query = ref('');
const results = ref([]);

const searchTokens = debounce(async () => {
    if (query.value.length < 2) {
        results.value = [];
        return;
    }
    try {
        const response = await axios.get(`/api/tokens/search?q=${query.value}`);
        results.value = response.data;
    } catch (error) {
        console.error('Error searching tokens:', error);
        results.value = [];
    }
}, 300); // Debounce API calls
</script>

<style scoped>
/* Add basic styling if needed */
.token-search {
    position: relative;
}
</style>
